import { ListPaginationMeta } from "utils/helpers/pagination";

export interface BodyTypeRow {
  bodyTypeId: number;
  bodyTypeName: string;
}

export interface BodyTypeForm {
  number: string;
  bodyTypeName: string;
}

export enum FieldType {
  String = "string",
  Number = "number",
}

export const FieldValues: Record<keyof BodyTypeForm, FieldType> = {
  number: FieldType.Number,
  bodyTypeName: FieldType.String,
};

export type BodyTypeListMeta = ListPaginationMeta;

export interface BodyTypeListResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: BodyTypeRow[];
  meta?: BodyTypeListMeta;
}

export interface BodyTypeUpdatePayload {
  id: number;
  bodyTypeName: string;
}

export interface BodyTypeUpdateResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data?: BodyTypeRow;
}

export interface BodyTypeState {
  loading: boolean;
  saving: boolean;
  list: BodyTypeRow[];
  page: number;
  perPage: number;
  meta: BodyTypeListMeta;
  error: string | null;
  isAddModalOpen: boolean;
  form: BodyTypeForm;
}
